import { useQuery } from "react-query";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";

async function fetchPumpageSummary(token, permitNdx, year) {
  const { data } = await axios.get(
    `${process.env.REACT_APP_ENDPOINT}/api/pumpage-entry/summary`,
    {
      headers: { Authorization: `Bearer ${token}` },
      params: { permit_ndx: permitNdx, year },
    }
  );
  return data; // either a record or null
}

export function usePumpageSummary(permitNdx, year) {
  const { getAccessTokenSilently } = useAuth0();

  return useQuery(
    ["pumpage-summary", permitNdx, year],
    async () => {
      const token = await getAccessTokenSilently();
      return fetchPumpageSummary(token, permitNdx, year);
    },
    {
      enabled: !!permitNdx && !!year,
      keepPreviousData: true,
    }
  );
}
